import { render } from "./Art-frame.vue?vue&type=template&id=12bec288"
import script from "./Art-frame.vue?vue&type=script&lang=js"
export * from "./Art-frame.vue?vue&type=script&lang=js"

import "./Art-frame.vue?vue&type=style&index=0&id=12bec288&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__